module.exports = __webpack_public_path__ + "img/dropdown_arrow.29600054.svg";